module.exports = __webpack_public_path__ + "static/img/2-19-错发退货退款完成.872a9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-19-错发退货退款完成.png
// module id = 1355
// module chunks = 0